/*
 * Silph TCG — sélection de prix des pages collection (tranches cliquables).
 *
 * Trois points ont dicté cette écriture, tous vérifiés dans assets/facets.js :
 *
 * 1. Le formulaire de facettes écoute `input`, PAS `change`. Écrire dans les champs puis émettre
 *    `change` ne relance donc AUCUN filtrage — c'était le défaut de la version à curseurs, où le
 *    filtrage ne repartait que par ricochet, via l'événement `input` natif des poignées.
 * 2. L'état sélectionné est rendu par Liquid, pas ici : Dawn remplace le bloc de facettes à chaque
 *    filtrage, un état porté par le JavaScript serait perdu. D'où une simple délégation sur
 *    `document`, qui couvre aussi les blocs fraîchement rendus.
 * 3. Les deux champs texte sont les seuls champs nommés du bloc, et le formulaire est resérialisé
 *    en entier à chaque envoi : un seul événement suffit à emporter les deux bornes.
 */
(function () {
  'use strict';

  function champs(bloc) {
    return [
      bloc.querySelector('input[name*="price.gte"]'),
      bloc.querySelector('input[name*="price.lte"]'),
    ];
  }

  // « 12,50 » et « 1 250,00 » doivent se lire pareil : la boutique est en français.
  function nombre(valeur) {
    if (valeur === null || valeur === undefined || valeur === '') return null;
    var n = parseFloat(String(valeur).replace(/\s/g, '').replace(',', '.'));
    return isNaN(n) ? null : n;
  }

  /*
   * Dawn recopie la borne d'un champ dans le `data-` de l'autre pour brider la saisie. Ces
   * attributs datent de l'état PRÉCÉDENT : sans remise d'accord après une écriture programmée, la
   * saisie manuelle suivante se fait ramener de force à l'ancienne borne (choisir « moins de 10 € »
   * puis taper 120 dans « De » ramenait à 10). Le plafond d'origine est lu sur le champ MAX, dont
   * Dawn ne réécrit jamais le `data-max`.
   */
  function normaliser(paire) {
    var plafond = paire[1].dataset.max || '';
    paire[0].setAttribute('data-min', '0');
    paire[0].setAttribute('data-max', paire[1].value !== '' ? paire[1].value : plafond);
    paire[1].setAttribute('data-min', paire[0].value !== '' ? paire[0].value : '0');
  }

  // Allume la tranche qui correspond exactement au couple (min, max) courant.
  function synchroniser(bloc) {
    var paire = champs(bloc);
    var min = nombre(paire[0] && paire[0].value);
    var max = nombre(paire[1] && paire[1].value);

    bloc.querySelectorAll('.silph-prix__tranche').forEach(function (tranche) {
      var correspond = nombre(tranche.dataset.gte) === min && nombre(tranche.dataset.lte) === max;
      tranche.classList.toggle('is-active', correspond);
      tranche.setAttribute('aria-pressed', correspond ? 'true' : 'false');
    });
  }

  function appliquer(bloc, gte, lte) {
    var paire = champs(bloc);
    if (!paire[0] || !paire[1]) return;

    paire[0].value = gte;
    paire[1].value = lte;
    normaliser(paire);
    synchroniser(bloc);

    // Le seul événement que le formulaire écoute. `bubbles` est indispensable : l'écouteur est
    // posé sur le <form>, pas sur le champ.
    paire[1].dispatchEvent(new Event('input', { bubbles: true }));
  }

  document.addEventListener('click', function (evt) {
    var tranche = evt.target.closest && evt.target.closest('.silph-prix__tranche');
    if (!tranche) return;
    var bloc = tranche.closest('price-range');
    if (!bloc) return;

    // Re-cliquer la tranche active l'annule : le geste d'annulation est au même endroit que celui
    // de sélection, plutôt que dans un « Effacer » à aller chercher ailleurs.
    var annule = tranche.classList.contains('is-active');
    appliquer(
      bloc,
      annule ? '' : tranche.dataset.gte || '',
      annule ? '' : tranche.dataset.lte || ''
    );
  });

  // Saisie manuelle : la tranche correspondante s'allume d'elle-même, sinon toutes s'éteignent.
  // Aucun filtrage déclenché ici — l'événement `input` natif du champ s'en charge déjà, avec
  // l'anti-rebond de Dawn.
  document.addEventListener('input', function (evt) {
    var champ = evt.target;
    if (!champ.classList || !champ.classList.contains('silph-prix__valeur')) return;
    var bloc = champ.closest('price-range');
    if (bloc) synchroniser(bloc);
  });
})();
